const sendProducts = (data)=>{
    fetch('http://buenchaval.com/sendProducts', {
        method: "POST",
        headers: {
            'Access-Control-Allow-Origin':'*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(res =>{
        console.log(res.body)
    })
};

export {sendProducts};